import Cookies from "js-cookie";

const SessionManager = {
    // ---------------- COOKIES (Client-Readable) ----------------
    setCookie: (name, value, days = 7) => {
        const safeDays = Math.max(Number(days) || 7, 7);
        Cookies.set(name, value, { expires: safeDays, path: "/" });
    },

    getCookie: (name) => {
        return Cookies.get(name);
    },

    removeCookie: (name) => {
        Cookies.remove(name, { path: "/" });
    },

    // ---------------- SESSION STORAGE ----------------
    setSession: (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
    },

    getSession: (key) => {
        const data = localStorage.getItem(key);
        try {
            return JSON.parse(data);
        } catch {
            return data;
        }
    },

    removeSession: (key) => {
        localStorage.removeItem(key);
    },

    clearSession: () => {
        localStorage.clear();
    }
};

export default SessionManager;